module.exports = __webpack_public_path__ + "img/img22.75d2d29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img22.jpg
// module id = 288
// module chunks = 0